
import { Route, Routes, useLocation, Outlet } from 'react-router-dom';
import Home from './pages/home';
import Category from '../src/pages/category.jsx';
import Post from '../src/pages/post.jsx';
import ContactUs from '../src/pages/contactUs.jsx';
import CompanyIntroduction from '../src/pages/companyIntroduction.jsx';
import ChartPage from '../src/pages/chart_page/chartPage.jsx';
import Navbar from './layout/navbar/navbar';
import Footer from './layout/footer/footer';
import LandingAssets from './layout/Layout';
import { isMobile } from 'react-device-detect';

const LayoutWithHeaderFooter = () => {
    const location = useLocation();
    const noNavbarRoutes = ['/login', '/sign-up', '/sign-up/form', '/change-password'];
    const shouldShowNavbar = isMobile || !noNavbarRoutes.includes(location.pathname);

    return (
        <LandingAssets>
            {shouldShowNavbar && <Navbar />}
            <Outlet />
            <Footer force />
        </LandingAssets>
    );
};

const RouterComponent = () => {
    return (
        <Routes>
            <Route element={<LayoutWithHeaderFooter />}>
                <Route path="/" element={<Home />} />
                <Route path="/chart" element={<ChartPage />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/category/:categoryKey" element={<Category />} />
                <Route path="/News/:categoryKey" element={<Category />} />
                <Route path="/post/:postId" element={<Post />} />
                <Route path="/company-introduction" element={<CompanyIntroduction />} />
            </Route>
        </Routes>
    );
};

export default RouterComponent;
